import {Component, inject, OnInit} from '@angular/core';
import {TranslatePipe, TranslateService} from '@ngx-translate/core';
import {ReactiveFormsModule} from '@angular/forms';
import {ActivatedRoute, Router, RouterLink} from '@angular/router';
import {finalize} from 'rxjs';
import {NzAlertModule} from 'ng-zorro-antd/alert';
import {NzButtonModule} from 'ng-zorro-antd/button';
import {NzCardModule} from 'ng-zorro-antd/card';
import {NzFormModule} from 'ng-zorro-antd/form';
import {NzNotificationService} from 'ng-zorro-antd/notification';
import {AuthFlowService} from '../../core/services/auth-flow.service';
import {PsdFields} from '../../shared/psd-fields/psd-fields';
import {createPsdForm} from '../../shared/psd-fields/psd-form';

@Component({
  selector: 'app-reset-password',
  standalone: true,
  imports: [
    TranslatePipe,
    ReactiveFormsModule,
    RouterLink,
    NzAlertModule,
    NzButtonModule,
    NzCardModule,
    NzFormModule,
    PsdFields,
  ],
  templateUrl: './reset-password.html',
  styleUrl: './reset-password.css'
})
export class ResetPassword implements OnInit {
  private readonly translate = inject(TranslateService);
  private readonly authFlow = inject(AuthFlowService);
  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);
  private readonly notification = inject(NzNotificationService);

  protected token = '';
  protected isSubmitting = false;
  protected errorMessage = '';

  readonly form = createPsdForm();

  ngOnInit(): void {
    this.token = this.route.snapshot.queryParamMap.get('token') ?? '';
    if (!this.token) {
      this.errorMessage = this.translate.instant('resetPsd.invalidLink');
    }
  }

  submit(): void {
    if (this.form.invalid || !this.token) {
      this.form.markAllAsTouched();
      return;
    }

    const {newPsd, confirmPsd} = this.form.getRawValue();

    this.errorMessage = '';
    this.isSubmitting = true;

    this.authFlow.resetPsd({token: this.token, newPsd, confirmPsd})
      .pipe(finalize(() => this.isSubmitting = false))
      .subscribe({
        next: () => {
          this.notification.success(this.translate.instant('common.success'), this.translate.instant('resetPsd.changed'));
          this.router.navigate(['/login']);
        },
        error: (err) => {
          this.errorMessage = err?.error?.error
            ?? this.translate.instant('resetPsd.error');
        }
      });
  }
}
